
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/quickEditEngine/components/styles/componentControlWrapper.scss.css.virtualfile';
        module.exports = {"quickEditComponentControlWrapper":"_quickEditComponentControlWrapper_1kup6_1"};